import { ThemeProvider } from "@mui/material/styles"
import { IRootState } from "app/model"
import { getStore } from "app/store/store"
import { history } from "app/tools/history"
import React from "react"
import "react-big-calendar/lib/css/react-big-calendar.css"
import { connect, Provider } from "react-redux"
import "resources/css/reset.css"
import { MainLayout } from "ui/components/main-layout/MainLayout"
import { CustomRouter } from "ui/components/router/CustomRouter"

export interface IThemeProps {
  theme: { [key: string]: any }
}

const AppFn = (props: IThemeProps) => (
  <ThemeProvider theme={props.theme}>
    <CustomRouter history={history}>
      <MainLayout />
    </CustomRouter>
  </ThemeProvider>
)

const AppConnect = connect(
  (state: IRootState): IThemeProps => ({
    theme: state.ui.theme
  })
)(AppFn)

export const App = (): JSX.Element => (
  <Provider store={getStore()}>
    <AppConnect />
  </Provider>
)
